import { type BankAccountId, BankImportId, Currency } from '@previo/codebooks'

export class BankAccount {
  constructor(
    public readonly id: BankAccountId,
    public readonly name: string,
    public readonly currency: Currency,
    public readonly bankAccountNumber: string,
    public readonly code: BankImportId,
    public readonly swift: string,
    public readonly autoImportValid: boolean,
  ) {}
}
